import { getPaywallCurrencyPrecision } from "@circle-react/helpers/paywalls/currencies";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import type { PaywallCurrencySmallestUnit } from "@circle-react/types/Paywall";

import type { InstallmentCouponPreviewScenario } from "./installmentCouponPaymentSelection";
import {
  calculateInstallmentPurchaseValue as calculateCore,
  type InstallmentCoupon,
} from "./installmentPurchaseValueCore";

type Coupon = Pick<
  NonNullable<PaywallCheckoutPreview["paywall_coupon"]>,
  "amount" | "duration" | "type"
>;

interface InstallmentPurchaseValueInput {
  coupon?: Coupon;
  currencySmallestUnit: PaywallCurrencySmallestUnit;
  installmentsCount: number;
  previewScenario: InstallmentCouponPreviewScenario;
  upfrontPaymentAmount: number;
  value: number;
}

export const calculateInstallmentPurchaseValue = (
  input: InstallmentPurchaseValueInput,
): number | null => {
  const coupon: InstallmentCoupon | undefined = input.coupon
    ? {
        amount: Number(input.coupon.amount),
        duration: input.coupon.duration,
        type: input.coupon.type,
      }
    : undefined;

  return calculateCore({
    ...input,
    coupon,
    currencyPrecision: getPaywallCurrencyPrecision({
      smallest_unit: input.currencySmallestUnit,
    }),
  });
};
